module.exports = __webpack_public_path__ + "img/noPrizeText.7033c96f.png";